import { Component, Input } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-client-avatar',
  imports: [AvatarModule, TooltipModule],
  templateUrl: './client-avatar.component.html',
  styleUrl: './client-avatar.component.scss',
})
export class ClientAvatarComponent {
  @Input() clientName: string = '';

  get initials(): string {
    if (!this.clientName) return '';
    const initials = this.clientName
      .split(' ')
      .filter(Boolean)
      .map((part) => part[0].toUpperCase())
      .join('');
    return initials;
  }
}
